import createReactClass from 'create-react-class';
import _ from 'lodash';
import React from 'react';
import GeometryMixin from '../../../../mixins/geometry-mixin';

export default createReactClass({
  displayName: 'polyline',
  mixins: [GeometryMixin],

  getInitialState() {
    return { value: this.sanatize(this.props) };
  },

  getDefaultProps() {
    return {
      value: [],
      colour: 'black',
      scale: { x: 0, y: 0 },
      strokeWidth: 2,
      hoverWidth: 2,
      isFaded: false,
      isHovered: false
    };
  },

  UNSAFE_componentWillReceiveProps(next) {
    return this.setState({ value: this.sanatize(next) });
  },

  sanatize(props) {
    const s = props.scale;
    const values = props.value;
    if (values == null) {
      return [];
    }
    return _.compact(
      values.map((v, i) => {
        if (i === values.length - 1) {
          return;
        }
        return {
          x1: this.toX(v.x, s),
          y1: this.toY(v.y, s),
          x2: this.toX(values[i + 1].x, s),
          y2: this.toY(values[i + 1].y, s)
        };
      })
    );
  },

  render() {
    let { strokeWidth } = this.props;
    if (this.props.isHovered) {
      strokeWidth = strokeWidth * this.props.hoverWidth;
    }

    const opacity = this.props.isFaded ? 0.3 : 1.0;

    const lines = this.state.value.map((v, i) => {
      return (
        <line
          key={i}
          x1={v.x1}
          y1={v.y1}
          x2={v.x2}
          y2={v.y2}
          opacity={opacity}
          stroke={this.props.colour}
          strokeWidth={strokeWidth}
        />
      );
    });
    return <g>{lines}</g>;
  }
});
